var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.33V8.5c0-1.24-.43-2.31-1.3-3.18C18.33 4.44 17.27 4 16 4s-2.33.44-3.2 1.32c-.87.88-1.3 1.94-1.3 3.18v.83H6.67V28h18.66V9.33H20.5Zm-8-.83c0-.98.34-1.8 1.02-2.47.68-.67 1.51-1 2.48-1s1.81.33 2.48 1c.68.67 1.02 1.49 1.02 2.47v.83h-7V8.5Zm11.8 18.47H7.7v-16.6h3.8v4h1v-4h7v4h1v-4h3.8v16.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/Basket.0a1585c490ca5fbbd5ca2048c9c609f1.svg";
export { ForwardRef as ReactComponent };